import { Box, HStack, Text, AmplifyIcon } from '@cdl/heartbeat-react';
import { PropsWithChildren } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GenericPicker } from '../../../plot/components/GenericPicker';
import * as layoutActions from '../../../layout/actions/layout.actions';
import { gainSelector } from '../../../layout/selectors/layout.selectors';
import { FilterClassifications } from '../basic/FilterClassifications';

export const BaseClustersHeader: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const dispatch = useDispatch();
  const gain = useSelector(gainSelector);

  const changeGain = (value: 1 | -1) => {
    const newGain = gain * 2 ** value;
    if (newGain >= 0.125 && newGain <= 16) {
      dispatch(layoutActions.update({ update: { gain: newGain } }));
    }
  };

  return (
    <HStack
      display='flex'
      flexDirection='row'
      mt='s'
      px='m'
      justifyContent='space-between'
    >
      <Text textStyle='label' color='neutral.0'>
        Base Clusters
      </Text>
      <FilterClassifications />
      <HStack spacing='m'>
        <AmplifyIcon color='neutral.0' m='auto' fontSize='xl' />
        <Box width='5.5rem'>
          <GenericPicker title={`x${gain}`} onChange={changeGain} />
        </Box>
        {children}
      </HStack>
    </HStack>
  );
};
